import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { StaffState } from "@/types/staff";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Staff } from "@/models/staff";

const state: StaffState = {
  single: new Staff(),
  pagination: new Pagination(),
};

export const staff: Module<StaffState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
